<app-badge color="dark-red"
           [outline]="true"
           i18n="@@badge.mainCompanyBadge">
    Hauptbetrieb
</app-badge>
